import React, { useState } from 'react'
import { Button, Container, Box, Toolbar, Typography, MenuItem, Menu, AppBar, IconButton, Avatar, Grid, Grow } from '@mui/material'
import logomeka from '../../assets/logo.png'
import icondiscover from '../../assets/discover_vector.svg'
import iconstats from '../../assets/charts_vector.svg'
import iconevent from '../../assets/event_vector.svg'
import iconmusic from '../../assets/music_vector.svg'
import { useNavigate } from 'react-router-dom'
import Player from '../player/Player'
import { QueueModalProps, withQueueModal } from '../../core/providers/QueueProvider'
import { ModalProviderValue, withModal } from '../../core/providers/ModalProvider'
import withMK from '../../hoc/withMK'
import { artworkForMediaItem } from '../../utils/Utils'
import { image_cover } from '../player/Player.module.css'
import MusicNoteIcon from '@mui/icons-material/MusicNote'
import SearchDialog from '../dialog/SearchDialog'
import StylesDialog from '../dialog/StylesDialog'

const pages = [{title: 'Évènement', logo: iconevent}, {title: 'Musicothèque', logo: iconmusic}, {title: 'Découverte', path: '/', logo: icondiscover}, {title: 'Stats', logo: iconstats}]

interface BottomMenuProps extends MKProps, QueueModalProps {
	modal: ModalProviderValue,
	user: any
}

const BottomMenu = ({user, mk}: BottomMenuProps) => {
    const navigate = useNavigate()
    const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
	const nowPlayingItem = mk && mk.instance ? mk.instance.queue.currentItem : undefined
	const artworkURL = artworkForMediaItem(nowPlayingItem, 600)

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    }

    const handleCloseNavMenu = (name: string) => {
        setAnchorElNav(null);
		if (name === 'Découverte') {
			goToHome()
		}
    }

    const goToHome = () => {
        navigate(`/`)
    }

	const goToUser = async () => {
        navigate(user ? `/profile` : `/login`)
    }

    return <AppBar position="static" color='primary' sx={{position: { xs: 'absolute', md: 'absolute', lg: 'inherit'}, display: { xs: 'block', md: 'block', lg: 'none'}, bottom: 0, left: 0,  backgroundColor: '#7C7CCF00', zIndex: 1000, backdropFilter: 'blur(1.5rem)'}}>
      	<Container maxWidth="xl">
        	<Toolbar disableGutters>
			{ !nowPlayingItem 
			? <Avatar variant='square' alt="logo meka" src={logomeka} onClick={goToHome} sx={{ display: { xs: 'none', md: 'block' }}} />
			: <Grid sx={{display: { xs: 'grid', md: 'none' }}}>
                <Grid size={{xs: 3, md: 0, lg: 0}} alignSelf={'start'} sx={{height: '100%', display: {xs:'none',md:'grid',lg:'none'}}} >
                    { artworkURL 
                        ? <Avatar variant='square' src={artworkURL} className='image-fit-height' alt="placeholder cover"/>
                        : <Avatar variant='square' sx={image_cover} alt="placeholder cover"><MusicNoteIcon/></Avatar>
                    }
                </Grid>

                <Grid size={{xs: 0, md: 4, lg: 4}} alignSelf={'start'} sx={{height: '100%', display: {xs:'none',md:'block',lg:'block'}}} >
                    { artworkURL
                        ? <img src={artworkURL} className='image-fit' alt="placeholder cover"/>
                        : <Avatar variant='square' sx={image_cover} alt="placeholder cover"><MusicNoteIcon/></Avatar>
                    }
                </Grid>
			</Grid>
			}
          	<Box sx={{ flexGrow: 1 , display: { xs: 'flex', md: 'none' } }}>
				<IconButton
					size="large"
					aria-label="site menu"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					onClick={handleOpenNavMenu}
					color="inherit"
				>
					<Avatar variant='square' src={pages.find(page => page?.path === window.location.pathname)?.logo ?? logomeka} sx={{}}/>
				</IconButton>
				<Menu
					id="menu-appbar"
					anchorEl={anchorElNav}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					keepMounted
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					slots={{transition: Grow}}
					open={Boolean(anchorElNav)}
					onClose={handleCloseNavMenu}
					sx={{ display: { xs: 'block', md: 'none' }, left: '0', '& .MuiMenu-paper' : { backgroundColor: '#00000030', backdropFilter: 'blur(1.5rem)', left: '0!important', boxShadow: 'none' }}}
				>
				{pages.filter(page => page?.path !== window.location.pathname).map((page) => (
					<MenuItem key={page.title} onClick={() => handleCloseNavMenu(page.title)} color='primary' sx={{mb: 1}} >
						<Avatar variant='square' sizes='small' src={page.logo} color={'primary'} alt='menu logo' sx={{mr: 1, width: 35, height: 35}}/>
						<Typography sx={{ textAlign: 'center' }} color={page?.path === window.location.pathname ? 'secondary.light' : 'white' }>{page.title}</Typography>
					</MenuItem>
				))}
				</Menu>
          	</Box>
          	{ !nowPlayingItem 
			? null
			: <Box sx={{display: { xs: 'grid', md: 'none' }}}>
				{ artworkURL
					? <Avatar variant='square' src={artworkURL} className='image-fit-height' alt="placeholder cover"/>
					: <Avatar variant='square' sx={image_cover} alt="placeholder cover"><MusicNoteIcon/></Avatar>
				}
			</Box>
			}
			<Typography sx={{flexGrow: nowPlayingItem ? 0 : 1}}></Typography>
			<Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
				{pages.map((page) => (
				<Button
					key={page.title}
					onClick={() => handleCloseNavMenu(page.title)}
					color={page?.path === window.location.pathname ? 'inherit' : 'secondary'}
					sx={{ my: 2, color: 'white', display: 'block' }}
				>
					{page.title}
				</Button>
				))}
			</Box>
			<Box sx={{ flexGrow: 0}}>
				{ artworkURL ? <Player /> : ''}
			</Box>
			<Box sx={{ flexGrow: 0, ml: 1, borderRadius: '50%'}}>
				<SearchDialog />
			</Box>
			{
				window.location.pathname === '/'
				? <Box sx={{ flexGrow: 0, ml: 1, borderRadius: '50%'}}>
					<StylesDialog discoverData={null} />
				</Box>
				: ''
			}
			<Box sx={{ flexGrow: 0, ml: 1, backgroundColor: '#FFF', borderRadius: '50%'}}>
				<IconButton sx={{padding: '4px'}} onClick={() => goToUser()}>
					{ user ? <Avatar alt="User avatar" sx={{width: { xs: '35px', md: '40px', lg: '8vh' }, height: { xs: '35px', md: '40px', lg: '8vh' }}} src={user.avatar_url}  /> : <Avatar  alt="User avatar" />}
				</IconButton>
			</Box>
        </Toolbar>
      </Container>
    </AppBar>
}

const bindings = {
	[MusicKit.Events.mediaItemDidChange]: 'mediaItem',
	[MusicKit.Events.queueItemsDidChange]: 'queueItems',
	[MusicKit.Events.queuePositionDidChange]: 'queuePosition',
	[MusicKit.Events.playbackStateDidChange]: 'playbackState',
}

export default withMK(
	withQueueModal(withModal( BottomMenu )), 
	bindings
)
